import {useEffect, useState} from 'react';

type Props = {
  elementId: string;
  isValueToggle?: boolean;
};
export const useIntersectionObserver = (props: Props) => {
  const {elementId, isValueToggle = true} = props;
  const [isIntersected, setIsIntersected] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsIntersected(true);
          } else if (isValueToggle) {
            setIsIntersected(false);
          }
        });
      },
      {
        root: null,
        threshold: 0.25,
      },
    );

    const element = document.getElementById(elementId);

    if (!element) {
      return;
    }

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [elementId, isIntersected, isValueToggle]);

  return isIntersected;
};
